namespace $ { $mol_style_attach( "mol/svg/text/box/box.view.css",
 "[mol_svg_text_box_back] {\n\tstroke: none;\n\tfill: var(--mol_theme_back);\n\ttransition: none;\n}\n"
) }